import { useCallback } from 'react'

import { Header } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import * as PaymentButtons from '@features/payments/buttons'
import { useTravelRuleRequired } from '@features/users/hooks/travel-rule'
import { routes } from '@services/sections/modal/routes'
import { useSegment, SegmentEvents } from '@services/segment'
import useTranslation from 'next-translate/useTranslation'

export const AddressBookHeader: React.FC = () => {
  const { t } = useTranslation('address-book/containers')
  const { router } = useModal()
  const { track } = useSegment()
  const { travelRuleSingaporeRequired } = useTravelRuleRequired()

  const handleClick = useCallback(() => {
    track(SegmentEvents.AddWalletAddressClicked)

    if (travelRuleSingaporeRequired) {
      router.push(routes.account.addressBook.addNewAddress.ownershipDisclaimer)
      return
    }

    router.push(routes.account.addressBook.addNewAddress.selectRecipient)
  }, [track, travelRuleSingaporeRequired, router])

  return (
    <Header>
      <Header.Head title={t`address-book-header.title`}>
        <PaymentButtons.AddressBook onClick={handleClick} variant="primary">
          {t('address-book-header.addAddress')}
        </PaymentButtons.AddressBook>
      </Header.Head>
    </Header>
  )
}
